const brandPrimary = "#ff8038";
const brandPrimaryHover = "#ff9550";
const brandPrimaryActive = "#e36a1f";
const brandPrimaryMuted = "#ffb48a";
const brandSecondary = "#fff1e6";
const brandNeutral = "#f8f9fb";
const brandDark = "#1f2a37";
export const editorTheme = {
  palette: {
    "txt-primary": brandDark,
    "txt-secondary": "#4f5d78",
    "txt-secondary-invert": "#fdfdff",
    "txt-placeholder": "#a3a6b8",
    "txt-warning": "#b0721f",
    "txt-error": "#c0392b",
    "txt-info": "#1e73d6",

    "accent-primary": brandPrimary,
    "accent-primary-hover": brandPrimaryHover,
    "accent-primary-active": brandPrimaryActive,
    "accent-primary-disabled": "#ffd6b8",
    "accent-secondary-disabled": "#ffe6d4",
    "accent-stateless": brandPrimary,
    "accent-stateless_0_4_opacity": "rgba(255, 128, 56, 0.4)",
    accent_0_5_5_opacity: "rgba(255, 128, 56, 0.55)",
    accent_0_5_opacity: "rgba(255, 128, 56, 0.5)",
    accent_0_7_opacity: "rgba(255, 128, 56, 0.7)",
    accent_1_2_opacity: "rgba(255, 128, 56, 0.12)",
    accent_1_8_opacity: "rgba(255, 128, 56, 0.18)",
    accent_2_8_opacity: "rgba(255, 128, 56, 0.28)",
    accent_4_0_opacity: "rgba(255, 128, 56, 0.4)",

    "bg-grey": "#edf0f6",
    "bg-stateless": brandNeutral,
    "bg-active": "#e6ebf5",
    "bg-base-light": "#fcfdff",
    "bg-base-medium": "#e7eaf3",
    "bg-primary": brandPrimary,
    "bg-primary-light": "#ffd8bb",
    "bg-primary-hover": brandPrimaryHover,
    "bg-primary-active": brandPrimaryMuted,
    "bg-primary-stateless": brandPrimary,
    "bg-primary-0-5-opacity": "rgba(255, 128, 56, 0.5)",
    "bg-secondary": brandSecondary,
    "bg-hover": "#fff5ed",
    "bg-green": "#e7f6ed",
    "bg-green-medium": "#c7ead5",
    "bg-blue": "#e2efff",
    "bg-red": "#ffe6e2",
    "bg-red-light": "#fff1ed",
    "background-red-medium": "#fbd0c9",
    "bg-orange": "#ffe3d1",
    "bg-tooltip": brandDark,

    "icon-primary": brandPrimary,
    "icons-primary-opacity-0-6": "rgba(255, 128, 56, 0.6)",
    "icons-secondary": "#ffb68f",
    "icons-placeholder": "#a3a6b8",
    "icons-invert": "#fdfdff",
    "icons-muted": "#ccd2e0",
    "icons-primary-hover": brandPrimaryHover,
    "icons-secondary-hover": "#ffa26c",

    "btn-primary-text": "#ffffff",
    "btn-primary-text-0-6": "rgba(255, 255, 255, 0.6)",
    "btn-primary-text-0-4": "rgba(255, 255, 255, 0.4)",
    "btn-disabled-text": "#ffd9c2",
    "btn-secondary-text": brandPrimary,

    "link-primary": brandPrimary,
    "link-stateless": brandPrimary,
    "link-hover": brandPrimaryHover,
    "link-active": brandPrimaryActive,
    "link-muted": "#9aa0b8",
    "link-pressed": "#c45f23",

    "borders-primary": brandPrimary,
    "borders-primary-hover": brandPrimaryHover,
    "borders-secondary": "#ffd0b0",
    "borders-strong": brandPrimaryActive,
    "borders-invert": "#fdfdff",
    "border-hover-bottom": brandPrimaryHover,
    "border-active-bottom": brandPrimaryActive,
    "border-primary-stateless": brandPrimary,
    "borders-disabled": "#ffe1cc",
    "borders-button": "#ffb88f",
    "borders-item": "#f2d6c6",
    "borders-base-light": "#e7eaf3",
    "borders-base-medium": "#ccd2e0",
    "borders-green": "#33a56f",
    "borders-green-medium": "#61d392",
    "borders-red": "#f06449",

    "active-secondary": "#ffe9d8",
    "active-secondary-hover": "#ffd7ba",

    tag: "#ffe3cc",
    "states-error-disabled-text": "#fbd0c9",

    error: "#f06449",
    "error-0-28-opacity": "rgba(240, 100, 73, 0.28)",
    "error-0-12-opacity": "rgba(240, 100, 73, 0.12)",
    "error-hover": "#dc4e36",
    "error-active": "#ba3f2b",
    success: "#2fa36b",
    "success-hover": "#228855",
    "success-Active": "#176b41",
    warning: "#ffad33",
    "warning-hover": "#e69a2b",
    "warning-active": "#c38223",
    info: "#1e73d6",
    modified: "#8e6bff",

    red: "#f06449",
    orange: brandPrimary,
    salad: "#8dd15c",
    green: "#2fa36b",
    blue: "#1e73d6",
    indigo: "#5b67ff",
    violet: "#8b5cf6",
    pink: "#ec4899",

    "gradient-right": "linear-gradient(90deg, #ff8038 0%, #ff9f63 100%)",
    "extra-0-3-overlay": "rgba(31, 42, 55, 0.3)",
    "gradient-right-active": "linear-gradient(90deg, #ff9550 0%, #ffb06c 100%)",
    "gradient-right-hover": "linear-gradient(90deg, #ffa166 0%, #ffc086 100%)",
    "extra-0-5-overlay": "rgba(31, 42, 55, 0.5)",
    "extra-0-7-overlay": "rgba(31, 42, 55, 0.7)",
    "extra-0-9-overlay": "rgba(31, 42, 55, 0.9)",
    "red-0-1-overlay": "rgba(240, 100, 73, 0.1)",
    "orange-0-1-overlay": "rgba(255, 128, 56, 0.1)",
    "accent-0-8-overlay": "rgba(255, 128, 56, 0.8)",
    "green-0-2-Overlay": "rgba(47, 163, 107, 0.2)",
    "white-0-7-8-overlay": "rgba(255, 255, 255, 0.78)",

    link: brandPrimary,
    camera: brandPrimary,
    "google-drive": "#0f9d58",
    dropbox: "#0061ff",
    "one-drive": "#094ab2",
    device: brandPrimary,
    instagram: "#d62976",
    "free-images": brandPrimary,
    "free-icons": brandPrimary,
    canvas: brandSecondary,
    box: brandNeutral,
    "screen-cast": brandPrimaryHover,
    unsplash: "#111827",

    "light-shadow": "rgba(255, 128, 56, 0.22)",
    "medium-shadow": "rgba(31, 42, 55, 0.18)",
    "large-shadow": "rgba(31, 42, 55, 0.26)",
    "x-large-shadow": "rgba(31, 42, 55, 0.34)",
  },
  typography: {
    fontFamily: "Roboto, Arial, sans-serif",
  },
} as const;
